import {EventEmitterService} from './event-emitter.service';

export class MenuInitService {

  public static init(identifier: string, isPrimary: boolean) {
    EventEmitterService.get('init').emit({ identifier,  isPrimary});
  }
}
